import styled from '@emotion/styled';
const Li = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  position: relative;
  text-align: center;
  list-style: none !important;
  padding: var(--spacing-4) var(--spacing-5);
  ${({ button }) => button && `padding: 0;`}

  &:focus-within {
    z-index: 1;
  }

  > button {
    color: var(--color);
    background: var(--background);

    padding: var(--spacing-4) var(--spacing-5);
    position: relative;
    width: 100%;
    text-align: center;

    svg,
    svg * {
      fill: currentColor;
      color: currentColor;
    }

    &:before {
      background-color: currentColor;
      border-radius: inherit;
      content: '';
      inset: 0;
      opacity: 0;
      position: absolute;
    }

    &:hover,
    &:focus-visible {
      &:before {
        opacity: 0.05;
      }
    }

    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }
  }
`;
/**
 *
 */
export const Item = ({ children, ...rest }) => <Li {...rest}>{children}</Li>;
